import './styles_guide.scss';
console.log('modules/styles_guide/styles_guide.js');
import { Current_Section_Indicator } from 'src/classes/Current_Section_Indicator';

const container = document.querySelector('[ data-elementor-post-type="page"]');

variable_colors();
navigation();

function variable_colors(){
    let style = getComputedStyle(document.body)
    container.querySelectorAll('.variable_colors .elementor-widget-container div').forEach(item=>{
        
        let color = document.createElement('div');
        color.style.background = style.getPropertyValue(item.dataset.color);
        item.append(color);

        let name = document.createElement('span');
        name.textContent = item.dataset.color;
        item.append(name);
    })
}

function navigation(){

    let nav_con = document.createElement('div');
    nav_con.classList.add('styles_guide_nav');
    container.append(nav_con);

    let sections = [];
    let nav_items = [];

    let section_indicator;
    
    let base_url = window.location.origin + window.location.pathname;

    for( let i = 0; i < container.children.length; i++ ) {
        let section = container.children[i];
        let heading = section.querySelector('h2.elementor-heading-title');
        if( !heading ) continue;
        
        let nav_item = document.createElement('div');
        nav_item.classList.add('item');
        nav_item.innerText = heading.innerText;

        nav_item.dataset.hash = '#'+heading.innerText;

        let url_hash = base_url+nav_item.dataset.hash;

        nav_con.append(nav_item);

        let offset = 41;
        nav_item.addEventListener('click',()=>{
			window.scrollTo({
				top: section.offsetTop - parseInt(offset),
				behavior: "smooth",
			});
            section_indicator.navigate(section);
            setTimeout(()=>section_indicator.navigate_complete(), 1000);

            window.history.pushState('', '', url_hash);
        });

        nav_items.push(nav_item);
        sections.push(section);
    }

    section_indicator = new Current_Section_Indicator(sections, nav_items);

    // hash scroll on load
    hash_scroll();
}

function hash_scroll(){
    if( !window.location.hash ) return;
    let nav = document.querySelector('.styles_guide_nav [data-hash="'+ window.location.hash +'"]');
    if( !nav ) return;
    setTimeout(()=>{
        nav.click();
    }, 1000);
}